import type React from 'react'
import styled from 'styled-components'

import { Checkbox } from '@components/ui/Checkbox'

import { FilterFormFormControlLabel } from '@components/filters/PageFilterBars/styles'
import { ChoicesWrapper } from '../styles'

const CustomLabelSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  line-height: 20px;
`

interface MultiChoiceFilterProps {
  config: FilterDialogMultiChoiceFilterConfig
  onChange: (values: FilterDialogMultiChoiceFilterProps['values']) => void
  values: FilterDialogMultiChoiceFilterProps['values']
}

export default function MultiChoiceFilter({ config: { options }, onChange, values }: MultiChoiceFilterProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newValues = event.target.checked
      ? [...values, event.target.name]
      : values.filter(value => value !== event.target.name)
    onChange(newValues)
  }

  return (
    <ChoicesWrapper>
      {options.map(({ value, label, icon }) => (
        <FilterFormFormControlLabel
          key={value}
          checked={values.includes(value)}
          name={value}
          onChange={handleChange}
          gap={10}
          control={<Checkbox />}
          label={
            <CustomLabelSpan>
              {icon}
              {label}
            </CustomLabelSpan>
          }
        />
      ))}
    </ChoicesWrapper>
  )
}
